import {
  GET_SECURITY_LOADING_REPORTS_ERROR,
  GET_SECURITY_LOADING_REPORTS_REQUEST,
  GET_SECURITY_LOADING_REPORTS_SUCCESS,
} from './constants';
import { SecurityLoadingReport } from './interfaces';

export const getSecurityLoadingReportsRequest = (
  branchId: string,
  startDate: string,
  endDate: string,
  notLoadedMode: string,
) => ({
  type: GET_SECURITY_LOADING_REPORTS_REQUEST,
  payload: { branchId, startDate, endDate, notLoadedMode },
});

export const getSecurityLoadingReportsSuccess = (reports: SecurityLoadingReport[]) => ({
  type: GET_SECURITY_LOADING_REPORTS_SUCCESS,
  payload: { reports },
});

export const getSecurityLoadingReportsError = (error: Error) => ({
  type: GET_SECURITY_LOADING_REPORTS_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof getSecurityLoadingReportsRequest>
  | ReturnType<typeof getSecurityLoadingReportsSuccess>
  | ReturnType<typeof getSecurityLoadingReportsError>;
